import React from 'react';

import {
  CarsFilterResultText,
  CarsFilterResultCount,
} from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { getStockCarList } from '@/store/reducers/cars-stock';
import { getFormattedResultText } from '@/modules/CarsStock/components/common.helpers';

function CarsFilterResult() {
  const carListCount = useTypedSelector(getStockCarList)?.meta?.count;

  if (!carListCount) {
    return null;
  }

  return (
    <CarsFilterResultText>
      <CarsFilterResultCount>{carListCount}</CarsFilterResultCount>{' '}
      {getFormattedResultText(carListCount)}
    </CarsFilterResultText>
  );
}

export default CarsFilterResult;
